var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ 'el-tiptap-editor': !_vm.disableClasses }},[_c('editor-content',{staticClass:"el-tiptap-editor__content",staticStyle:{"overflow-x":"initial"},attrs:{"editor":_vm.editor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }